export const PARTNERSHIPS = "/api/partnerships"
export const PARTNERSHIP = "/api/partnerships/:param"

export const EXPORT_PARTNERSHIPS = "/api/partnerships/export"
export const EXPORT_PARTNERSHIP = "/api/partnerships/:param/print"
export const ROUTE_OF_JUSTFIED = "/api/partnerships/:param/justified"

export const PARTNERSHIP_APPOINTMENTS_LIST = "/api/partnerships/:param/appointments"
export const PARTNERSHIP_APPOINTMENTS = "/api/appointments"
export const PARTNERSHIP_APPOINTMENT = "/api/appointments/:param"

export const DOCUMENTS = "/api/documents/partnership/:param"
export const DOCUMENT = "/api/documents/:param"

export const AVAILABILITIES = "/api/availabilities"

export const USER_APPOINTMENTS_LIST = "/api/appointments/cps"

export const USER_APPOINTMENTS = "/api/partnerships/:param/appointments/cp"
export const USER_APPOINTMENT = "/api/appointments/:param"

export const PARTNERSHIP_ACTIVATE = "/api/partnerships/:param/activate"
export const PARTNERSHIP_DEACTIVATE = "/api/partnerships/:param/deactivate"

export const PARTNERSHIP_DELETE = "/api/partnerships/:param/delete"
export const PARTNERSHIP_UNDELETE = "/api/partnerships/:param/undelete"

export const PARTNERSHIPS_ACTIVATE = "/api/partnerships/activate"
export const PARTNERSHIPS_DEACTIVATE = "/api/partnerships/deactivate"

export const PARTNERSHIPS_UNDELETE = "/api/partnerships/undelete"
export const PARTNERSHIPS_DELETE = "/api/partnerships/delete"
